import React from "react";
import { Link } from "react-router-dom";
import { WarningIcon } from "@phosphor-icons/react";

export default function RiskBanner() {
  return (
    <div data-testid="risk-banner" className="relative z-50 bg-[#1A1405] border-b border-[#FBBF24]/30 text-[#FDE68A]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-2 flex items-start gap-2 text-[11px] leading-snug">
        <WarningIcon size={14} weight="fill" className="mt-[1px] flex-shrink-0 text-[#FBBF24]" />
        <span className="sm:hidden" data-testid="risk-banner-mobile">
          <b>Risk warning:</b> software only, <b>not investment advice</b>. Trading involves substantial risk, including loss of capital.
          Results shown are <b>simulated</b> and not reliable indicators of future performance.{" "}
          <Link to="/legal" className="underline inline-block py-2">Full disclosure</Link>
        </span>
        <span className="hidden sm:inline">
          <b>Risk warning:</b> BotGenomix provides downloadable trading software for independent use - <b>not investment advice</b> or account
          management. Trading involves substantial risk, including loss of capital. Results shown are <b>backtests (simulated)</b> or{" "}
          <b>demo-account results (simulated funds)</b>, not real-money trading, and are not reliable indicators of future performance.{" "}
          <Link to="/legal" data-testid="risk-banner-legal-link" className="underline hover:text-white">Read the full disclosure</Link>
        </span>
      </div>
    </div>
  );
}
